import { render, staticRenderFns } from "./ReportDamageDropdownItem.vue?vue&type=template&id=6034a090"
import script from "./ReportDamageDropdownItem.vue?vue&type=script&lang=ts"
export * from "./ReportDamageDropdownItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports